import { Result } from "@praha/byethrow"
import { toast } from "sonner"
import { logClientPushEvent } from "../server/push.functions"
import { persistPushSubscription } from "./push-subscription-sync"
import { urlBase64ToUint8Array } from "./vapid"

export const subscribeToPush = async () => {
  if (typeof Notification === "undefined") throw new Error("notifications are not supported")
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
    throw new Error("service worker is not supported")
  }

  const permission = await Notification.requestPermission()
  if (permission !== "granted") throw new Error("permission denied")
  const registration = await navigator.serviceWorker.ready

  const subscribeResult = await Result.try({
    try: async () =>
      registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(import.meta.env.VITE_VAPID_PUBLIC_KEY),
      }),
    catch: (e) => e,
  })

  if (Result.isFailure(subscribeResult)) {
    const err = subscribeResult.error
    const name = err instanceof Error ? err.name : "UnknownError"
    const message = err instanceof Error ? err.message : String(err)
    toast.error(`Ошибка подписки на уведомления: ${name}: ${message}`)
    void logClientPushEvent({
      data: {
        event: "subscribe_error",
        name,
        message,
        userAgent: navigator.userAgent,
        permission: Notification.permission,
      },
    }).catch(() => undefined)
    throw err
  }

  const subscription = subscribeResult.value
  await persistPushSubscription(subscription)
  return subscription
}
